import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { EmployeeRoleTypes } from '../../enums/employees/EmployeeRoleTypes';
import { EmployeeUtil } from '../../utilities/employee.utilities';
import { GuardHelperService } from 'src/app/modules/auth/guard-helper.service';

@Injectable()
export class HubGuard{
  constructor(
    private readonly authService: AuthenticationService,
    private readonly router: Router,
    private readonly guardHelperService: GuardHelperService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.guardHelperService.canActivate(route, state, this.checkPermissions.bind(this));
  }

  checkPermissions(url: string): boolean {
    let result = false;
    const account = this.authService.getCurrentAccount();
    const employee = this.authService.getCurrentEmployee();
    const hasIncidentUserRole =
      EmployeeUtil.hasRole(employee, EmployeeRoleTypes.Hub_Admin) || EmployeeUtil.hasRole(employee, EmployeeRoleTypes.Hub_General);

    if (!account.isActive) {
      void this.router.navigateByUrl(`${account.accountUID}/unauthorized`);
    }

    if ((account.useAccountHub) && hasIncidentUserRole) {
      result = true;
    }

    if (!result) {
      this.authService.logout();
    }

    return result;
  }
}
